<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="conditionsDialog"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            Obchodní podmínky
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body legal">
          <h5 class="section">Úvodní ustanovení</h5>
          <ol>
            <li>
              Tyto obchodní podmínky (dále jen jako „obchodní podmínky“) jsou
              vydané podle § 1751 a násl. zákona č. 89/2012 Sb., občanský
              zákoník, ve znění pozdějších předpisů (dále jen jako „občanský
              zákoník“).
            </li>
            <li>
              Obchodní podmínky upravují smluvní vztah mezi prodávajícím:
              <ul>
                <li>obchodní firma: Pivo&amp;Co s.r.o.</li>
                <li>IČ: 09246746</li>
                <li>DIČ: CZ09246746</li>
                <li>sídlo: Litoměřická 405/9, Prosek, 190 00 Praha 9</li>
                <li>zapsané u Městského soudu v Praze, pod sp. zn. C 333217</li>
                <li>kontaktní údaje: Šimon Klíma</li>
                <li>email: simon.klima@hoppyhedgehog.cz</li>
                <li>telefon: + 420 724 044 780</li>
                <li>www: https://hoppyhedgehog.cz/</li>
              </ul>
              (dále jen jako „prodávající“) na straně jedné a fyzickou osobou
              spotřebitelem jako kupujícím (dále jen jako "kupující") na straně
              druhé vzniklý na základě kupní smlouvy uzavřené prostřednictvím
              internetového obchodu prodávajícího (dále jen jako "kupní
              smlouva"). Internetový obchod je prodávajícím provozován
              prostřednictvím webového rozhraní umístěného na webové stránce na
              výše uvedené internetové adrese (dále jen jako "internetový
              obchod").
            </li>
            <li>
              V případě jakýchkoli rozdílů mezi obchodními podmínkami a kupní
              smlouvou uzavřenou mezi prodávajícím a kupujícím má přednost text
              kupní smlouvy s tím, že obchodní podmínky tvoří nedílnou součást
              kupní smlouvy. Obchodní podmínky jsou vyhotoveny v českém jazyce.
              Kupní smlouvu lze uzavřít v českém jazyce.
            </li>
          </ol>

          <h5 class="section">Informace o zboží a cenách</h5>
          <ol>
            <li>
              Internetový obchod provozovaný prodávajícím obsahuje zboží
              nabízené prodávajícím k prodeji, a to včetně uvedení názvu
              produktu, ceny produktu a specifikace produktu z hlediska jeho
              základních vlastností. Cena produktu je vždy uvedena včetně daně z
              přidané hodnoty a všech souvisejících poplatků. Cena zboží
              nezahrnuje náklady na dopravu zboží ke kupujícímu, není-li v
              konkrétní nabídce uvedeno jinak. Ceny zboží zůstávají v platnosti
              po dobu, po kterou jsou zobrazovány v internetovém obchodě. Toto
              ustanovení nevylučuje sjednání kupní smlouvy za individuálně
              sjednaných podmínek.
            </li>

            <li>
              Veškeré nabídky prodeje zboží umístěné v katalogu internetového
              obchodu jsou informativního charakteru, nezávazné a prodávající
              není povinen uzavřít kupní smlouvu ohledně tohoto zboží.
            </li>

            <li>
              Internetový obchod obsahuje rovněž informace o nákladech spojených
              s balením a dodáním zboží. Informace o nákladech spojených s
              balením a dodáním zboží uvedené v internetovém obchodě platí pouze
              v případech, kdy je zboží doručováno v rámci území České
              republiky.
            </li>

            <li>
              Případné slevy z kupní ceny zboží nelze navzájem kombinovat,
              nedohodne-li se prodávající s kupujícím jinak.
            </li>
          </ol>

          <h5 class="section">Uživatelský účet</h5>
          <ol>
            <li>
              Na z&aacute;kladě registrace kupuj&iacute;c&iacute;ho
              proveden&eacute; v internetov&eacute;m obchodě může
              kupuj&iacute;c&iacute; přistupovat do sv&eacute;ho
              uživatelsk&eacute;ho rozhran&iacute;. Ze sv&eacute;ho
              uživatelsk&eacute;ho rozhran&iacute; (d&aacute;le jen jako
              "uživatelsk&yacute; &uacute;čet") může kupuj&iacute;c&iacute;
              prov&aacute;dět objedn&aacute;v&aacute;n&iacute; zbož&iacute;.
            </li>
            <li>
              Při registraci do uživatelsk&eacute;ho &uacute;čtu a při
              objedn&aacute;v&aacute;n&iacute; zbož&iacute; je
              kupuj&iacute;c&iacute; povinen uv&aacute;dět spr&aacute;vně a
              pravdivě v&scaron;echny &uacute;daje. &Uacute;daje uveden&eacute;
              v uživatelsk&eacute;m &uacute;čtu je kupuj&iacute;c&iacute;
              při&nbsp;jak&eacute;koliv jejich změně povinen aktualizovat.
              &Uacute;daje uveden&eacute; kupuj&iacute;c&iacute;m v
              uživatelsk&eacute;m &uacute;čtu a při
              objedn&aacute;v&aacute;n&iacute; zbož&iacute; jsou
              prod&aacute;vaj&iacute;c&iacute;m považov&aacute;ny za
              spr&aacute;vn&eacute;.
            </li>
            <li>
              Př&iacute;stup k uživatelsk&eacute;mu &uacute;čtu je zabezpečen
              uživatelsk&yacute;m jm&eacute;nem a heslem. Kupuj&iacute;c&iacute;
              je povinen zachov&aacute;vat mlčenlivost ohledně informac&iacute;
              nezbytn&yacute;ch k př&iacute;stupu do jeho uživatelsk&eacute;ho
              &uacute;čtu. Prod&aacute;vaj&iacute;c&iacute; nenese odpovědnost
              za př&iacute;padn&eacute; zneužit&iacute; uživatelsk&eacute;ho
              &uacute;čtu třet&iacute;mi osobami. Kupuj&iacute;c&iacute;
              nen&iacute; opr&aacute;vněn umožnit využ&iacute;v&aacute;n&iacute;
              uživatelsk&eacute;ho &uacute;čtu třet&iacute;m osob&aacute;m.
            </li>
            <li>
              Kupuj&iacute;c&iacute; bere na vědom&iacute;, že
              uživatelsk&yacute; &uacute;čet nemus&iacute; b&yacute;t
              dostupn&yacute; nepřetržitě, a to zejm&eacute;na s ohledem na
              nutnou &uacute;držbu hardwarov&eacute;ho a softwarov&eacute;ho
              vybaven&iacute; prod&aacute;vaj&iacute;c&iacute;ho nebo nutnou
              &uacute;držbu hardwarov&eacute;ho a softwarov&eacute;ho
              vybaven&iacute; třet&iacute;ch osob.
            </li>
          </ol>

          <h5 class="section">Objednávka a uzavření kupní smlouvy</h5>
          <ol>
            <li>
              Kupuj&iacute;c&iacute; prov&aacute;d&iacute; objedn&aacute;vku
              zbož&iacute; těmito způsoby:
              <ul>
                <li>
                  prostřednictv&iacute;m sv&eacute;ho uživatelsk&eacute;ho
                  &uacute;čtu, provedl-li předchoz&iacute; registraci
                  v&nbsp;internetov&eacute;m obchodě,
                </li>
                <li>
                  vyplněn&iacute;m objedn&aacute;vkov&eacute;ho formul&aacute;ře
                  bez registrace.
                </li>
              </ul>
            </li>
            <li>
              Pro &uacute;čely objedn&aacute;n&iacute; zbož&iacute;
              vypln&iacute; kupuj&iacute;c&iacute; objedn&aacute;vkov&yacute;
              formul&aacute;ř ve webov&eacute;m rozhran&iacute;.
              Objedn&aacute;vkov&yacute; formul&aacute;ř obsahuje zejm&eacute;na
              informace o:
              <ul>
                <li>
                  objedn&aacute;van&eacute;m zbož&iacute; vložen&eacute;
                  kupuj&iacute;c&iacute;m do elektronick&eacute;ho
                  n&aacute;kupn&iacute;ho ko&scaron;&iacute;ku
                  internetov&eacute;ho obchodu,
                </li>
                <li>způsob &uacute;hrady kupn&iacute; ceny zbož&iacute;,</li>
                <li>
                  &uacute;daje o požadovan&eacute;m způsobu doručen&iacute;
                  objedn&aacute;van&eacute;ho zbož&iacute; a
                </li>
                <li>
                  informace o n&aacute;kladech spojen&yacute;ch s
                  dod&aacute;n&iacute;m zbož&iacute;
                </li>
              </ul>
              (d&aacute;le společně jen jako "objedn&aacute;vka").
            </li>

            <li>
              Při zad&aacute;v&aacute;n&iacute; objedn&aacute;vky si
              kupuj&iacute;c&iacute; vybere zbož&iacute;, počet kusů
              zbož&iacute;, způsob platby a&nbsp;způsob doručen&iacute;
              zbož&iacute;.
            </li>
            <li>
              Před odesl&aacute;n&iacute;m objedn&aacute;vky
              prod&aacute;vaj&iacute;c&iacute;mu je kupuj&iacute;c&iacute;mu
              umožněno kontrolovat a měnit &uacute;daje, kter&eacute; do
              objedn&aacute;vky vložil, a to i s ohledem na možnost
              kupuj&iacute;c&iacute;ho zji&scaron;ťovat a opravovat chyby
              vnikl&eacute; při zad&aacute;v&aacute;n&iacute; dat do
              objedn&aacute;vky. Objedn&aacute;vku ode&scaron;le
              kupuj&iacute;c&iacute; prod&aacute;vaj&iacute;c&iacute;mu
              kliknut&iacute;m na tlač&iacute;tko "Objednat". &Uacute;daje
              uveden&eacute; v objedn&aacute;vce jsou
              prod&aacute;vaj&iacute;c&iacute;m považov&aacute;ny za
              spr&aacute;vn&eacute;. Podm&iacute;nkou platnosti
              objedn&aacute;vky je vyplněn&iacute; v&scaron;ech povinn&yacute;ch
              &uacute;dajů v&nbsp;objedn&aacute;vkov&eacute;m formul&aacute;ři a
              potvrzen&iacute; kupuj&iacute;c&iacute;ho o tom, že se
              sezn&aacute;mil s těmito obchodn&iacute;mi podm&iacute;nkami a s
              podm&iacute;nkami zpracov&aacute;n&iacute; osobn&iacute;ch
              &uacute;dajů a že s nimi souhlas&iacute;.
            </li>
            <li>
              Prod&aacute;vaj&iacute;c&iacute; je vždy opr&aacute;vněn v
              z&aacute;vislosti na charakteru objedn&aacute;vky (např.
              množstv&iacute; zbož&iacute;, v&yacute;&scaron;e kupn&iacute;
              ceny, předpokl&aacute;dan&eacute; n&aacute;klady na dopravu)
              pož&aacute;dat kupuj&iacute;c&iacute;ho o dodatečn&eacute;
              potvrzen&iacute; objedn&aacute;vky (např. p&iacute;semně či
              telefonicky).
            </li>
            <li>
              Smluvn&iacute; vztah mezi prod&aacute;vaj&iacute;c&iacute;m a
              kupuj&iacute;c&iacute;m vznik&aacute; a k uzavřen&iacute;
              kupn&iacute; smlouvy doch&aacute;z&iacute; okamžikem
              přijet&iacute;m objedn&aacute;vky
              prod&aacute;vaj&iacute;c&iacute;m. Přijet&iacute;
              objedn&aacute;vky potvrd&iacute; prod&aacute;vaj&iacute;c&iacute;
              kupuj&iacute;c&iacute;mu elektronickou po&scaron;tou, a to na
              adresu elektronick&eacute; po&scaron;ty kupuj&iacute;c&iacute;ho
              uvedenou v&nbsp;objedn&aacute;vce nebo v uživatelsk&eacute;m
              &uacute;čtu (d&aacute;le jen jako &bdquo;elektronick&aacute;
              adresa kupuj&iacute;c&iacute;ho&ldquo;).
            </li>
            <li>
              V př&iacute;padě, že někter&yacute; z požadavků uveden&yacute;ch v
              objedn&aacute;vce nemůže prod&aacute;vaj&iacute;c&iacute; splnit,
              za&scaron;le kupuj&iacute;c&iacute;mu na jeho elektronickou adresu
              pozměněnou nab&iacute;dku. Pozměněn&aacute; nab&iacute;dka se
              považuje za nov&yacute; n&aacute;vrh kupn&iacute; smlouvy a
              kupn&iacute; smlouva je v takov&eacute;m př&iacute;padě uzavřena
              potvrzen&iacute;m kupuj&iacute;c&iacute;ho o přijet&iacute;
              t&eacute;to nov&eacute; nab&iacute;dky
              prod&aacute;vaj&iacute;c&iacute;mu na jeho elektronickou adresu
              uvedenou v těchto obchodn&iacute;ch podm&iacute;nk&aacute;ch.
            </li>
            <li>
              Prod&aacute;vaj&iacute;c&iacute; je opr&aacute;vněn odstoupit od
              kupn&iacute; smlouvy v př&iacute;padě, že budou vyčerp&aacute;ny
              z&aacute;soby prod&aacute;vaj&iacute;c&iacute;ho nebo pokud
              prod&aacute;vaj&iacute;c&iacute; z&nbsp;jin&yacute;ch důvodů
              nebude schopen povinnosti z kupn&iacute; smlouvy splnit.
              Prod&aacute;vaj&iacute;c&iacute; bezodkladně informuje
              kupuj&iacute;c&iacute;ho prostřednictv&iacute;m
              elektronick&eacute; adresy uveden&eacute; v objedn&aacute;vce nebo
              v uživatelsk&eacute;m &uacute;čtu a vr&aacute;t&iacute;
              kupuj&iacute;c&iacute;mu ve lhůtě 14 dnů
              od&nbsp;ozn&aacute;men&iacute; o odstoupen&iacute; od kupn&iacute;
              smlouvy v&scaron;echny peněžn&iacute; prostředky včetně
              n&aacute;kladů na&nbsp;dod&aacute;n&iacute;, kter&eacute; od něho
              na z&aacute;kladě kupn&iacute; smlouvy přijal, a to bezhotovostně
              na bankovn&iacute; &uacute;čet určen&yacute;
              kupuj&iacute;c&iacute;m, popř. jin&yacute;m způsobem po
              vz&aacute;jemn&eacute; dohodě prod&aacute;vaj&iacute;c&iacute;ho a
              kupuj&iacute;c&iacute;ho.
            </li>
            <li>
              V př&iacute;padě, že do&scaron;lo ke zjevn&eacute;
              technick&eacute; chybě na straně
              prod&aacute;vaj&iacute;c&iacute;ho při uveden&iacute; ceny
              zbož&iacute; v internetov&eacute;m obchodě nebo v průběhu
              objedn&aacute;v&aacute;n&iacute;, nen&iacute;
              prod&aacute;vaj&iacute;c&iacute; povinen dodat
              kupuj&iacute;c&iacute;mu zbož&iacute; za tuto zcela zjevně chybnou
              cenu. Prod&aacute;vaj&iacute;c&iacute; informuje
              kupuj&iacute;c&iacute;ho o chybě bez zbytečn&eacute;ho odkladu a
              za&scaron;le kupuj&iacute;c&iacute;mu na jeho elektronickou adresu
              pozměněnou nab&iacute;dku.
            </li>
            <li>
              N&aacute;klady vznikl&eacute; kupuj&iacute;c&iacute;mu při
              použit&iacute; komunikačn&iacute;ch prostředků na d&aacute;lku
              v&nbsp;souvislosti s uzavřen&iacute;m kupn&iacute; smlouvy
              (n&aacute;klady na internetov&eacute; připojen&iacute;,
              n&aacute;klady na&nbsp;telefonn&iacute; hovory apod.),
              hrad&iacute; kupuj&iacute;c&iacute; s&aacute;m. Tyto
              n&aacute;klady se neli&scaron;&iacute; od z&aacute;kladn&iacute;
              sazby.
            </li>
          </ol>

          <h5 class="section">Cena zboží, platební podmínky</h5>
          <ol>
            <li>
              Cenu zbož&iacute; a př&iacute;padn&eacute; n&aacute;klady
              spojen&eacute; s dod&aacute;n&iacute;m zbož&iacute; podle
              kupn&iacute; smlouvy může kupuj&iacute;c&iacute; uhradit
              n&aacute;sleduj&iacute;c&iacute;mi způsoby:
              <ul>
                <li>
                  bezhotovostně převodem na bankovn&iacute; &uacute;čet
                  prod&aacute;vaj&iacute;c&iacute;ho, kter&yacute;
                  prod&aacute;vaj&iacute;c&iacute; sděl&iacute;
                  kupuj&iacute;c&iacute;mu v r&aacute;mci procesu
                  objedn&aacute;vky (d&aacute;le jen jako "&uacute;čet
                  prod&aacute;vaj&iacute;c&iacute;ho"),
                </li>
                <li>
                  v hotovosti při před&aacute;n&iacute; zbož&iacute; na
                  dob&iacute;rku, pokud prod&aacute;vaj&iacute;c&iacute;
                  umožňuje dopravu zbož&iacute; prostřednictv&iacute;m
                  přepravce,
                </li>
                <li>
                  v hotovosti nebo platebn&iacute; kartou při osobn&iacute;m
                  odběru, pokud prod&aacute;vaj&iacute;c&iacute; umožňuje
                  osobn&iacute; odběr zbož&iacute;,
                </li>
                <li>
                  d&aacute;rkov&yacute;m certifik&aacute;tem nebo slevovou
                  pouk&aacute;zkou, pokud to prod&aacute;vaj&iacute;c&iacute;
                  umožňuje. V př&iacute;padě, že nomin&aacute;ln&iacute; hodnota
                  těchto voucherů je vy&scaron;&scaron;&iacute; než cena
                  objedn&aacute;van&eacute;ho zbož&iacute;, nen&iacute; zbytek
                  hodnoty voucherů refundov&aacute;n.
                </li>
              </ul>
            </li>

            <li>
              Společně s kupn&iacute; cenou je kupuj&iacute;c&iacute; povinen
              uhradit prod&aacute;vaj&iacute;c&iacute;mu n&aacute;klady
              spojen&eacute; s balen&iacute;m a dod&aacute;n&iacute;m
              zbož&iacute; ve smluven&eacute; v&yacute;&scaron;i. Nen&iacute;-li
              d&aacute;le uvedeno v&yacute;slovně jinak, rozum&iacute; se
              d&aacute;le kupn&iacute; cenou i n&aacute;klady spojen&eacute; s
              dod&aacute;n&iacute;m zbož&iacute;.
            </li>
            <li>
              V př&iacute;padě platby v hotovosti či v př&iacute;padě platby na
              dob&iacute;rku je kupn&iacute; cena splatn&aacute; při
              převzet&iacute; zbož&iacute;.&nbsp;
            </li>
            <li>
              V př&iacute;padě bezhotovostn&iacute; platby je z&aacute;vazek
              kupuj&iacute;c&iacute;ho uhradit kupn&iacute; cenu splněn
              okamžikem přips&aacute;n&iacute; př&iacute;slu&scaron;n&eacute;
              č&aacute;stky na &uacute;čet prod&aacute;vaj&iacute;c&iacute;ho. V
              př&iacute;padě bezhotovostn&iacute; platby je kupn&iacute; cena
              splatn&aacute; do 2 pracovn&iacute;ch dnů od
              odesl&aacute;n&iacute; objedn&aacute;vky.
              Prod&aacute;vaj&iacute;c&iacute; je opr&aacute;vněn odstoupit
              od&nbsp;kupn&iacute; smlouvy v př&iacute;padě, že kupn&iacute;
              cena nen&iacute; přips&aacute;na v t&eacute;to lhůtě na jeho
              bankovn&iacute; &uacute;čet. Nen&iacute;-li dohodnuto jinak, je
              kupuj&iacute;c&iacute; opr&aacute;vněn si zbož&iacute;
              převz&iacute;t až po &uacute;pln&eacute;m zaplacen&iacute; jeho
              ceny. V př&iacute;padě bezhotovostn&iacute; platby je
              kupuj&iacute;c&iacute; povinen uhradit kupn&iacute; cenu
              zbož&iacute; společně s&nbsp;uveden&iacute;m variabiln&iacute;ho
              symbolu platby, kter&yacute; je sdělen kupuj&iacute;c&iacute;mu v
              r&aacute;mci procesu objedn&aacute;vky.
            </li>
            <li>
              Prod&aacute;vaj&iacute;c&iacute; nepožaduje od
              kupuj&iacute;c&iacute;ho předem ž&aacute;dnou z&aacute;lohu či
              jinou obdobnou platbu. &Uacute;hrada kupn&iacute; ceny před
              odesl&aacute;n&iacute;m zbož&iacute; nen&iacute; z&aacute;lohou.
            </li>
            <li>
              Podle z&aacute;kona o evidenci tržeb je
              prod&aacute;vaj&iacute;c&iacute; povinen vystavit
              kupuj&iacute;c&iacute;mu daňov&yacute; doklad - fakturu.
              Daňov&yacute; doklad - faktura je vystavov&aacute;na v
              elektronick&eacute; podobě po převzet&iacute; zbož&iacute;
              kupuj&iacute;c&iacute;m a je zas&iacute;l&aacute;na na jeho
              elektronickou adresu. Prod&aacute;vaj&iacute;c&iacute; je
              z&aacute;roveň povinen zaevidovat přijatou tržbu u spr&aacute;vce
              daně on-line, v př&iacute;padě technick&eacute;ho v&yacute;padku
              pak nejpozději do 48 hodin od uskutečněn&iacute; evidovan&eacute;
              tržby.
            </li>
            <li>
              Př&iacute;padn&eacute; slevy z&nbsp;ceny zbož&iacute;
              poskytnut&eacute; prod&aacute;vaj&iacute;c&iacute;m
              kupuj&iacute;c&iacute;mu nelze vz&aacute;jemně kombinovat.
            </li>
          </ol>
          <h5 class="section">Přeprava a dodání zboží</h5>
          <ol>
            <li>
              Zbož&iacute; je kupuj&iacute;c&iacute;mu dod&aacute;no:
              <ul>
                <li>
                  na adresu určenou kupuj&iacute;c&iacute;m v objedn&aacute;vce
                  nebo
                </li>
                <li>prostřednictv&iacute;m osobn&iacute;ho odběru.</li>
              </ul>
            </li>
            <li>
              Volba způsobu dod&aacute;n&iacute; zbož&iacute; se
              prov&aacute;d&iacute; během objedn&aacute;v&aacute;n&iacute;
              zbož&iacute;.
            </li>
            <li>
              N&aacute;klady na dod&aacute;n&iacute; zbož&iacute; v
              z&aacute;vislosti na způsobu odesl&aacute;n&iacute; a
              převzet&iacute; zbož&iacute; jsou uvedeny v&nbsp;objedn&aacute;vce
              kupuj&iacute;c&iacute;ho a v potvrzen&iacute; přijet&iacute;
              objedn&aacute;vky prod&aacute;vaj&iacute;c&iacute;m.
            </li>
            <li>
              Je-li prod&aacute;vaj&iacute;c&iacute; podle kupn&iacute; smlouvy
              povinen dodat zbož&iacute; na m&iacute;sto určen&eacute;
              kupuj&iacute;c&iacute;m v&nbsp;objedn&aacute;vce, je
              kupuj&iacute;c&iacute; povinen převz&iacute;t zbož&iacute; při
              dod&aacute;n&iacute;. V př&iacute;padě, že je z důvodů na straně
              kupuj&iacute;c&iacute;ho nutno zbož&iacute; doručovat opakovaně
              nebo jin&yacute;m způsobem, než bylo uvedeno
              v&nbsp;objedn&aacute;vce, je kupuj&iacute;c&iacute; povinen
              uhradit n&aacute;klady spojen&eacute; s opakovan&yacute;m
              doručov&aacute;n&iacute;m zbož&iacute;, resp. n&aacute;klady
              spojen&eacute; s jin&yacute;m způsobem doručen&iacute;.
            </li>
            <li>
              Při převzet&iacute; zbož&iacute; od přepravce je
              kupuj&iacute;c&iacute; povinen zkontrolovat neporu&scaron;enost
              obalů zbož&iacute; a&nbsp;v př&iacute;padě jak&yacute;chkoliv
              z&aacute;vad toto neprodleně ozn&aacute;mit přepravci. V
              př&iacute;padě shled&aacute;n&iacute; poru&scaron;en&iacute; obalu
              svědč&iacute;c&iacute;ho o neopr&aacute;vněn&eacute;m
              vniknut&iacute; do z&aacute;silky nemus&iacute;
              kupuj&iacute;c&iacute; z&aacute;silku od přepravce převz&iacute;t.
            </li>
            <li>
              Kupuj&iacute;c&iacute; nab&yacute;v&aacute; vlastnick&eacute;
              pr&aacute;vo ke zbož&iacute; zaplacen&iacute;m cel&eacute;
              kupn&iacute; ceny za zbož&iacute;, včetně n&aacute;kladů na
              dod&aacute;n&iacute;. Odpovědnost za nahodilou zk&aacute;zu,
              po&scaron;kozen&iacute; či ztr&aacute;tu zbož&iacute;
              přech&aacute;z&iacute; na&nbsp;kupuj&iacute;c&iacute;ho okamžikem
              převzet&iacute; zbož&iacute; nebo okamžikem, kdy měl
              kupuj&iacute;c&iacute; povinnost zbož&iacute; převz&iacute;t, ale
              v rozporu s kupn&iacute; smlouvou tak neučinil.
            </li>
          </ol>

          <h5 class="section">Odstoupení od smlouvy kupujícím</h5>

          <ol>
            <li>
              V souladu s ustanoven&iacute;m &sect; 1829 odst. 1
              občansk&eacute;ho z&aacute;kon&iacute;ku m&aacute;
              kupuj&iacute;c&iacute; spotřebitel pr&aacute;vo od kupn&iacute;
              smlouvy odstoupit, a to do 14 dnů
              <ul>
                <li>od převzet&iacute; zbož&iacute;, nebo</li>
                <li>
                  ode dne převzet&iacute; posledn&iacute; dod&aacute;vky
                  zbož&iacute; v př&iacute;padě, že na z&aacute;kladě
                  kupn&iacute; smlouvy je dod&aacute;v&aacute;no několik druhů
                  zbož&iacute;, nebo se zbož&iacute; skl&aacute;d&aacute; z
                  několika č&aacute;st&iacute;, nebo
                </li>
                <li>
                  ode dne převzet&iacute; prvn&iacute; dod&aacute;vky
                  zbož&iacute;, je-li předmětem smlouvy pravideln&aacute;
                  opakovan&aacute; dod&aacute;vka zbož&iacute;.
                </li>
              </ul>
            </li>
            <li>
              Kupuj&iacute;c&iacute; spotřebitel nemůže podle &sect; 1837
              občansk&eacute;ho z&aacute;kon&iacute;ku od kupn&iacute; smlouvy
              mimo jin&eacute; odstoupit v těchto př&iacute;padech:
              <ul>
                <li>
                  zbož&iacute; zakoupen&eacute; kupuj&iacute;c&iacute;m bylo
                  upraveno podle př&aacute;n&iacute; kupuj&iacute;c&iacute;ho
                  nebo pro jeho osobu,
                </li>
                <li>
                  zbož&iacute; zakoupen&eacute; kupuj&iacute;c&iacute;m
                  podl&eacute;h&aacute; rychl&eacute; zk&aacute;ze (včetně
                  alkoholick&yacute;ch n&aacute;pojů, u nichž je vzhledem k
                  jejich charakteru, např. absence pasterizace omezena doba
                  použitelnosti), nebo bylo po dod&aacute;n&iacute;
                  nen&aacute;vratně sm&iacute;seno s jin&yacute;m zbož&iacute;m,
                </li>
                <li>
                  zbož&iacute; bylo dod&aacute;no kupuj&iacute;c&iacute;mu v
                  uzavřen&eacute;m obalu, kter&eacute; kupuj&iacute;c&iacute; z
                  obalu vyňal, a&nbsp;z&nbsp;hygienick&yacute;ch důvodů jej
                  nen&iacute; možno vr&aacute;tit.
                </li>
              </ul>
            </li>

            <li>
              Pro dodržen&iacute; lhůty pro odstoupen&iacute; od smlouvy
              mus&iacute; kupuj&iacute;c&iacute; odeslat
              prohl&aacute;&scaron;en&iacute; o odstoupen&iacute; ve lhůtě pro
              odstoupen&iacute; od smlouvy. Kupuj&iacute;c&iacute; může pro
              odstoupen&iacute; od kupn&iacute; smlouvy využ&iacute;t
              vzorov&yacute; formul&aacute;ř k odstoupen&iacute; od kupn&iacute;
              smlouvy poskytovan&yacute; prod&aacute;vaj&iacute;c&iacute;m, jenž
              tvoř&iacute; př&iacute;lohu těchto obchodn&iacute;ch
              podm&iacute;nek. Odstoupen&iacute; od kupn&iacute; smlouvy
              za&scaron;le kupuj&iacute;c&iacute; na elektronickou adresu
              obchod@hoppyhedgehog.cz. Prod&aacute;vaj&iacute;c&iacute;
              potvrd&iacute; kupuj&iacute;c&iacute;mu bez zbytečn&eacute;ho
              odkladu přijet&iacute; dokumentu a n&aacute;sledně bude
              kupuj&iacute;c&iacute;ho kontaktovat za &uacute;čelem domluvy
              ohledně dal&scaron;&iacute;ho postupu.
            </li>
            <li>
              V př&iacute;padě odstoupen&iacute; od smlouvy se kupn&iacute;
              smlouva od poč&aacute;tku ru&scaron;&iacute; s t&iacute;m, že
              kupuj&iacute;c&iacute; je povinen zbož&iacute; zaslat nebo předat
              prod&aacute;vaj&iacute;c&iacute;mu nejpozději do 14 dnů od
              odstoupen&iacute; od&nbsp;smlouvy. Lhůta se považuje za dodrženou,
              pokud kupuj&iacute;c&iacute; zbož&iacute; ode&scaron;le zpět před
              uplynut&iacute;m 14 dnů. Kupuj&iacute;c&iacute; nese
              n&aacute;klady spojen&eacute; s navr&aacute;cen&iacute;m
              zbož&iacute; prod&aacute;vaj&iacute;c&iacute;mu, a to i v tom
              př&iacute;padě, kdy zbož&iacute; nemůže b&yacute;t vr&aacute;ceno
              pro svou povahu obvyklou po&scaron;tovn&iacute; cestou.
              Zbož&iacute; by mělo b&yacute;t prod&aacute;vaj&iacute;c&iacute;mu
              vr&aacute;ceno nepo&scaron;kozen&eacute; a neopotřeben&eacute; a,
              je-li to možn&eacute;, v původn&iacute;m obalu. N&aacute;rok na
              n&aacute;hradu &scaron;kody vznikl&eacute; na zbož&iacute; je
              prod&aacute;vaj&iacute;c&iacute; opr&aacute;vněn jednostranně
              započ&iacute;st proti n&aacute;roku kupuj&iacute;c&iacute;ho na
              vr&aacute;cen&iacute; kupn&iacute; ceny. Ve lhůtě 14 dnů od
              odstoupen&iacute; od vr&aacute;cen&iacute; zbož&iacute;
              kupuj&iacute;c&iacute;m je prod&aacute;vaj&iacute;c&iacute;
              opr&aacute;vněn prov&eacute;st přezkoum&aacute;n&iacute;
              vr&aacute;cen&eacute;ho zbož&iacute;, zejm&eacute;na za
              &uacute;čelem zji&scaron;těn&iacute;, zda vr&aacute;cen&eacute;
              zbož&iacute; nen&iacute; po&scaron;kozeno, opotřebeno či
              č&aacute;stečně spotřebov&aacute;no.
            </li>
            <li>
              Odstoup&iacute;-li kupuj&iacute;c&iacute; od smlouvy,
              vr&aacute;t&iacute; mu prod&aacute;vaj&iacute;c&iacute;
              bezodkladně, nejpozději v&scaron;ak do&nbsp;14&nbsp;dnů od
              odstoupen&iacute; od smlouvy, v&scaron;echny peněžn&iacute;
              prostředky včetně n&aacute;kladů na dod&aacute;n&iacute;,
              kter&eacute; od něho přijal, a to stejn&yacute;m způsobem,
              jak&yacute;m je přijal. Prod&aacute;vaj&iacute;c&iacute;
              vr&aacute;t&iacute; kupuj&iacute;c&iacute;mu přijat&eacute;
              peněžn&iacute; prostředky jin&yacute;m způsobem jen tehdy, pokud s
              t&iacute;m kupuj&iacute;c&iacute; souhlas&iacute;. Jestliže
              kupuj&iacute;c&iacute; zvolil jin&yacute; než
              nejlevněj&scaron;&iacute; způsob dod&aacute;n&iacute;
              zbož&iacute;, kter&yacute; prod&aacute;vaj&iacute;c&iacute;
              nab&iacute;z&iacute;, vr&aacute;t&iacute;
              prod&aacute;vaj&iacute;c&iacute; kupuj&iacute;c&iacute;mu
              n&aacute;klady na dod&aacute;n&iacute; zbož&iacute; ve
              v&yacute;&scaron;i odpov&iacute;daj&iacute;c&iacute;
              nejlevněj&scaron;&iacute;mu nab&iacute;zen&eacute;mu způsobu
              dod&aacute;n&iacute; zbož&iacute;.
            </li>
            <li>
              Odstoup&iacute;-li kupuj&iacute;c&iacute; od kupn&iacute; smlouvy,
              nen&iacute; prod&aacute;vaj&iacute;c&iacute; povinen vr&aacute;tit
              přijat&eacute; peněžn&iacute; prostředky kupuj&iacute;c&iacute;mu
              dř&iacute;ve, než mu kupuj&iacute;c&iacute; zbož&iacute;
              před&aacute; nebo prok&aacute;že, že zbož&iacute;
              prod&aacute;vaj&iacute;c&iacute;mu odeslal.
            </li>
            <li>
              Je-li společně se zbož&iacute;m poskytnut kupuj&iacute;c&iacute;mu
              d&aacute;rek, je darovac&iacute; smlouva mezi
              prod&aacute;vaj&iacute;c&iacute;m a&nbsp;kupuj&iacute;c&iacute;m
              uzavřena s&nbsp;rozvazovac&iacute; podm&iacute;nkou, že dojde-li
              k&nbsp;odstoupen&iacute; od kupn&iacute; smlouvy
              kupuj&iacute;c&iacute;m, pozb&yacute;v&aacute; darovac&iacute;
              smlouva ohledně takov&eacute;ho d&aacute;rku &uacute;činnosti
              a&nbsp;kupuj&iacute;c&iacute; je povinen spolu se zbož&iacute;m
              prod&aacute;vaj&iacute;c&iacute;mu vr&aacute;tit i
              poskytnut&yacute; d&aacute;rek.
            </li>
          </ol>
          <h5 class="section">Reklamace</h5>
          <ol>
            <li>
              Pr&aacute;va a povinnosti smluvn&iacute;ch stran ohledně
              pr&aacute;v z vadn&eacute;ho plněn&iacute; se ř&iacute;d&iacute;
              &sect; 1914 až 1925, &sect;&nbsp;2099 až 2117 a &sect; 2161 až
              2174 občansk&eacute;ho z&aacute;kon&iacute;ku a z&aacute;konem č.
              634/1992 Sb., o ochraně spotřebitele, ve zněn&iacute;
              pozděj&scaron;&iacute;ch předpisů.
            </li>
            <li>
              Kupuj&iacute;c&iacute; je povinen zbož&iacute; po jeho
              převzet&iacute; prohl&eacute;dnout tak, aby zjistil
              př&iacute;padn&eacute; vady a&nbsp;po&scaron;kozen&iacute;
              zbož&iacute;. Pokud zbož&iacute; vady vykazuje, je
              kupuj&iacute;c&iacute; opr&aacute;vněn tuto skutečnost bez
              zbytečn&eacute;ho odkladu ozn&aacute;mit
              prod&aacute;vaj&iacute;c&iacute;mu. V př&iacute;padě
              v&yacute;skytu vady může kupuj&iacute;c&iacute;
              prod&aacute;vaj&iacute;c&iacute;mu předložit reklamaci a
              d&aacute;le postupovat v souladu s &sect; 2106 a n&aacute;sl.
              občansk&eacute;ho z&aacute;kon&iacute;ku. Volbu způsobu reklamace
              m&aacute; kupuj&iacute;c&iacute;.
            </li>
            <li>
              Reklamaci uplatňuje kupuj&iacute;c&iacute; u
              prod&aacute;vaj&iacute;c&iacute;ho na adrese provozovny,
              př&iacute;padně i v s&iacute;dle obchodn&iacute; firmy.
            </li>
            <li>
              Za okamžik uplatněn&iacute; reklamace se považuje okamžik, kdy
              prod&aacute;vaj&iacute;c&iacute; obdržel od
              kupuj&iacute;c&iacute;ho reklamovan&eacute; zbož&iacute;.
            </li>
            <li>
              Prod&aacute;vaj&iacute;c&iacute; se zavazuje
              prostřednictv&iacute;m elektronick&eacute; po&scaron;ty informovat
              kupuj&iacute;c&iacute;ho o stavu reklamace a&nbsp;jej&iacute;m
              vyř&iacute;zen&iacute;.
            </li>
            <li>
              Reklamace mus&iacute; b&yacute;t vyř&iacute;zena bezodkladně,
              nejpozději do 30 dnů ode dne uplatněn&iacute; reklamace, pokud se
              prod&aacute;vaj&iacute;c&iacute; s kupuj&iacute;c&iacute;m
              nedohodne na del&scaron;&iacute; lhůtě. Marn&eacute;
              uplynut&iacute; t&eacute;to lhůty se považuje za podstatn&eacute;
              poru&scaron;en&iacute; smlouvy a kupuj&iacute;c&iacute; m&aacute;
              pr&aacute;vo od kupn&iacute; smlouvy odstoupit.
            </li>
            <li>
              V př&iacute;padě opr&aacute;vněn&eacute; reklamace m&aacute;
              kupuj&iacute;c&iacute; pr&aacute;vo na n&aacute;hradu
              &uacute;čelně vynaložen&yacute;ch n&aacute;kladů vznikl&yacute;ch
              v souvislosti s uplatněn&iacute;m reklamace. Toto pr&aacute;vo
              může kupuj&iacute;c&iacute;
              u&nbsp;prod&aacute;vaj&iacute;c&iacute;ho uplatnit ve lhůtě do
              jednoho měs&iacute;ce po uplynut&iacute; z&aacute;ručn&iacute;
              doby, v opačn&eacute;m př&iacute;padě ho soud nemus&iacute;
              přiznat.
            </li>
          </ol>

          <h5 class="section">Doručování</h5>
          <ol>
            <li>
              Smluvn&iacute; strany si mohou ve&scaron;kerou p&iacute;semnou
              korespondenci vz&aacute;jemně doručovat prostřednictv&iacute;m
              elektronick&eacute; po&scaron;ty.
            </li>
            <li>
              Kupuj&iacute;c&iacute; doručuje prod&aacute;vaj&iacute;c&iacute;mu
              korespondenci na elektronickou adresu uvedenou v těchto
              obchodn&iacute;ch podm&iacute;nk&aacute;ch.
              Prod&aacute;vaj&iacute;c&iacute; doručuje kupuj&iacute;c&iacute;mu
              korespondenci na elektronickou adresu uvedenou v objedn&aacute;vce
              nebo v jeho uživatelsk&eacute;m &uacute;čtu.
            </li>
          </ol>

          <h5 class="section">Ochrana osobních údajů</h5>
          <ol>
            <li>
              Prod&aacute;vaj&iacute;c&iacute; se zavazuje, že osobn&iacute;
              &uacute;daje z&iacute;skan&eacute; v souvislosti se
              smluvn&iacute;m vztahem a&nbsp;registrac&iacute;, tedy
              &uacute;daje uveden&eacute; v registračn&iacute;m a
              objedn&aacute;vkov&eacute;m formul&aacute;ři, bude použ&iacute;vat
              pouze pro svoji potřebu a neposkytne je v ž&aacute;dn&eacute;
              podobě nikomu jin&eacute;mu.&nbsp;
            </li>
            <li>
              Pokud kupuj&iacute;c&iacute; neuděl&iacute;
              prod&aacute;vaj&iacute;c&iacute;mu v&yacute;slovn&eacute;
              svolen&iacute;, &uacute;daje o něm nesm&iacute;
              prod&aacute;vaj&iacute;c&iacute; už&iacute;vat jin&yacute;m
              způsobem než za &uacute;čelem plněn&iacute; ze smlouvy, vyjma
              elektronick&eacute; adresy, na kterou může
              prod&aacute;vaj&iacute;c&iacute; kupuj&iacute;c&iacute;mu
              zas&iacute;lat obchodn&iacute; sdělen&iacute;, pokud je
              kupuj&iacute;c&iacute; v&yacute;slovně
              neodm&iacute;tne.&nbsp;&nbsp;
            </li>
            <li>
              Tato sdělen&iacute; se mohou t&yacute;kat pouze obdobn&eacute;ho
              nebo souvisej&iacute;c&iacute;ho zbož&iacute;, jak&eacute;
              prod&aacute;vaj&iacute;c&iacute; nab&iacute;z&iacute;, a lze je
              kdykoliv jednoduch&yacute;m způsobem (např. kliknut&iacute;m na
              odkaz v obchodn&iacute;m sdělen&iacute;)
              odhl&aacute;sit.&nbsp;&nbsp;
            </li>
            <li>
              Elektronick&aacute; adresa bude za t&iacute;mto &uacute;čelem
              uchov&aacute;v&aacute;na po dobu 3 let od uzavřen&iacute;
              posledn&iacute; smlouvy mezi smluvn&iacute;mi stranami.&nbsp;
            </li>
            <li>
              Použ&iacute;v&aacute;n&iacute;m webov&yacute;ch str&aacute;nek
              https://hoppyhedgehog.cz/ souhlas&iacute; kupuj&iacute;c&iacute; s
              ukl&aacute;d&aacute;n&iacute;m tzv.&nbsp;cookies na jeho
              poč&iacute;tač. Tato cookies nebudou využ&iacute;v&aacute;na pro
              remarketing.&nbsp;
            </li>
            <li>
              Svou informačn&iacute; povinnost vůči kupuj&iacute;c&iacute;mu
              pln&iacute; prod&aacute;vaj&iacute;c&iacute; podle platn&eacute; a
              &uacute;činn&eacute; pr&aacute;vn&iacute; &uacute;pravy
              prostřednictv&iacute;m zvl&aacute;&scaron;tn&iacute;ho dokumentu -
              podm&iacute;nky zpracov&aacute;n&iacute; osobn&iacute;ch
              &uacute;dajů, kter&yacute; je kupuj&iacute;c&iacute;mu
              zpř&iacute;stupněn společně s&nbsp;těmito obchodn&iacute;mi
              podm&iacute;nkami při potvrzen&iacute; objedn&aacute;vky
              zbož&iacute;.
            </li>
          </ol>

          <h5 class="section">Mimosoudní řešení sporů</h5>

          <ol>
            <li>
              K mimosoudn&iacute;mu ře&scaron;en&iacute; spotřebitelsk&yacute;ch
              sporů z kupn&iacute; smlouvy je př&iacute;slu&scaron;n&aacute;
              Česk&aacute; obchodn&iacute; inspekce, se s&iacute;dlem
              &Scaron;těp&aacute;nsk&aacute; 567/15, 120 00 Praha 2, IČ: 000 20
              869, internetov&aacute; adresa:
              <a href="https://adr.coi.cz/cs">https://adr.coi.cz/cs</a>.
              Platformu pro ře&scaron;en&iacute; sporů on-line
              nach&aacute;zej&iacute;c&iacute; se na internetov&eacute; adrese
              <a href="http://ec.europa.eu/consumers/odr%20"
                >http://ec.europa.eu/consumers/odr</a
              >
              je možn&eacute; využ&iacute;t při ře&scaron;en&iacute; sporů mezi
              prod&aacute;vaj&iacute;c&iacute;m a&nbsp;kupuj&iacute;c&iacute;m z
              kupn&iacute; smlouvy.
            </li>
            <li>
              Evropsk&eacute; spotřebitelsk&eacute; centrum Česk&aacute;
              republika, se s&iacute;dlem &Scaron;těp&aacute;nsk&aacute; 567/15,
              120 00 Praha 2, internetov&aacute; adresa:
              <a href="https://evropskyspotrebitel.cz/%20"
                >https://evropskyspotrebitel.cz/</a
              >
              je kontaktn&iacute;m m&iacute;stem podle Nař&iacute;zen&iacute;
              Evropsk&eacute;ho parlamentu a Rady (EU) č. 524/2013 ze dne 21.
              května 2013 o ře&scaron;en&iacute; spotřebitelsk&yacute;ch sporů
              on-line a o změně nař&iacute;zen&iacute; (ES) č. 2006/2004 a
              směrnice 2009/22/ES (nař&iacute;zen&iacute; o ře&scaron;en&iacute;
              spotřebitelsk&yacute;ch sporů on-line).
            </li>
            <li>
              Prod&aacute;vaj&iacute;c&iacute; je opr&aacute;vněn k prodeji
              zbož&iacute; na z&aacute;kladě živnostensk&eacute;ho
              opr&aacute;vněn&iacute;. Živnostenskou kontrolu
              prov&aacute;d&iacute; v r&aacute;mci sv&eacute; působnosti
              př&iacute;slu&scaron;n&yacute; živnostensk&yacute; &uacute;řad.
              Česk&aacute; obchodn&iacute; inspekce vykon&aacute;v&aacute; ve
              vymezen&eacute;m rozsahu mimo jin&eacute; dozor nad
              dodržov&aacute;n&iacute;m z&aacute;kona č. 634/1992 Sb., o ochraně
              spotřebitele, ve zněn&iacute; pozděj&scaron;&iacute;ch předpisů.
            </li>
          </ol>

          <h5 class="section">Závěrečná ustanovení</h5>
          <ol>
            <li>
              Pokud vztah založen&yacute; kupn&iacute; smlouvou obsahuje
              mezin&aacute;rodn&iacute; (zahraničn&iacute;) prvek, pak strany
              sjedn&aacute;vaj&iacute;, že&nbsp;vztah se ř&iacute;d&iacute;
              česk&yacute;m pr&aacute;vem. Volbou pr&aacute;va podle
              předchoz&iacute; věty nen&iacute; kupuj&iacute;c&iacute;,
              kter&yacute; je&nbsp;spotřebitelem, zbaven ochrany, kterou mu
              poskytuj&iacute; ustanoven&iacute; pr&aacute;vn&iacute;ho
              ř&aacute;du, od nichž se nelze smluvně odch&yacute;lit, a jež
              by&nbsp;se v př&iacute;padě neexistence volby pr&aacute;va jinak
              použila dle&nbsp;ustanoven&iacute; čl. 6 odst. 1
              Nař&iacute;zen&iacute; Evropsk&eacute;ho parlamentu a&nbsp;Rady
              (ES) č. 593/2008 ze dne 17. června 2008 o&nbsp;pr&aacute;vu
              rozhodn&eacute;m pro smluvn&iacute; z&aacute;vazkov&eacute; vztahy
              (Ř&iacute;m&nbsp;I).&nbsp;
            </li>
            <li>
              V&scaron;echna pr&aacute;va k webov&yacute;m
              str&aacute;nk&aacute;m prod&aacute;vaj&iacute;c&iacute;ho,
              zejm&eacute;na autorsk&aacute; pr&aacute;va k obsahu, včetně
              rozvržen&iacute; str&aacute;nky, fotek, filmů, grafik,
              ochrann&yacute;ch zn&aacute;mek, loga a dal&scaron;&iacute;ho
              obsahu a prvků, n&aacute;lež&iacute;
              prod&aacute;vaj&iacute;c&iacute;mu. Je zak&aacute;z&aacute;no
              kop&iacute;rovat, upravovat nebo jinak použ&iacute;vat
              webov&eacute; str&aacute;nky nebo jejich č&aacute;st bez souhlasu
              prod&aacute;vaj&iacute;c&iacute;ho.
            </li>
            <li>
              Prod&aacute;vaj&iacute;c&iacute; nenese odpovědnost za chyby
              vznikl&eacute; v důsledku z&aacute;sahů třet&iacute;ch osob
              do&nbsp;internetov&eacute;ho obchodu nebo v důsledku jeho
              užit&iacute; v rozporu s jeho určen&iacute;m.
              Kupuj&iacute;c&iacute; nesm&iacute; při
              využ&iacute;v&aacute;n&iacute; internetov&eacute;ho obchodu
              použ&iacute;vat postupy, kter&eacute; by mohly m&iacute;t
              negativn&iacute; vliv na&nbsp;jeho provoz a nesm&iacute;
              vykon&aacute;vat ž&aacute;dnou činnost, kter&aacute; by mohla jemu
              nebo třet&iacute;m osob&aacute;m umožnit neopr&aacute;vněně
              zasahovat či neopr&aacute;vněně už&iacute;t programov&eacute;
              vybaven&iacute; nebo dal&scaron;&iacute; souč&aacute;sti
              tvoř&iacute;c&iacute; internetov&yacute; obchod a už&iacute;vat
              internetov&yacute; obchod nebo jeho č&aacute;sti či
              softwarov&eacute; vybaven&iacute; takov&yacute;m způsobem,
              kter&yacute; by byl v rozporu s jeho určen&iacute;m či
              &uacute;čelem.
            </li>
            <li>
              Je-li někter&eacute; ustanoven&iacute; obchodn&iacute;ch
              podm&iacute;nek neplatn&eacute; nebo ne&uacute;činn&eacute;, nebo
              se takov&yacute;m stane, nam&iacute;sto neplatn&yacute;ch
              ustanoven&iacute; nastoup&iacute; ustanoven&iacute;, jehož smysl
              se neplatn&eacute;mu ustanoven&iacute; co nejv&iacute;ce
              přibližuje. Neplatnost&iacute; nebo ne&uacute;činnost&iacute;
              jednoho ustanoven&iacute; nen&iacute; dotčena platnost
              ostatn&iacute;ch ustanoven&iacute;.
            </li>
            <li>
              Kupuj&iacute;c&iacute; t&iacute;mto přeb&iacute;r&aacute; na sebe
              nebezpeč&iacute; změny okolnost&iacute; ve smyslu &sect; 1765
              odst. 2 občansk&eacute;ho z&aacute;kon&iacute;ku.
            </li>
            <li>
              Prod&aacute;vaj&iacute;c&iacute; nen&iacute; ve vztahu ke
              kupuj&iacute;c&iacute;mu v&aacute;z&aacute;n ž&aacute;dn&yacute;mi
              kodexy chov&aacute;n&iacute; ve smyslu ustanoven&iacute; &sect;
              1826 odst. 1 p&iacute;sm. e) občansk&eacute;ho
              z&aacute;kon&iacute;ku.
            </li>
            <li>
              Kupn&iacute; smlouva včetně obchodn&iacute;ch podm&iacute;nek je
              archivov&aacute;na prod&aacute;vaj&iacute;c&iacute;m v
              elektronick&eacute; podobě a nen&iacute; př&iacute;stupn&aacute;.
            </li>
            <li>
              Zněn&iacute; obchodn&iacute;ch podm&iacute;nek může
              prod&aacute;vaj&iacute;c&iacute; měnit či doplňovat. T&iacute;mto
              ustanoven&iacute;m nejsou dotčena pr&aacute;va a povinnosti
              vznikl&eacute; po dobu &uacute;činnosti předchoz&iacute;ho
              zněn&iacute; obchodn&iacute;ch podm&iacute;nek.
            </li>
            <li>
              Př&iacute;lohu obchodn&iacute;ch podm&iacute;nek tvoř&iacute;
              vzorov&yacute; formul&aacute;ř pro odstoupen&iacute; od
              kupn&iacute; smlouvy.
            </li>
          </ol>
          <p>&nbsp;</p>
          <p>
            Tyto obchodn&iacute; podm&iacute;nky nab&yacute;vaj&iacute;
            &uacute;činnosti dnem 25. ř&iacute;jna 2020.
          </p>
          <p>V Praze dne 20. října 2020</p>

          
          <h5 style="text-align: center">Příloha 1. Vzorový formulář k odstoupení od kupní smlouvy</h5>
          <p>
          Formulář odstoupení od smlouvy stáhněte <a href="/assets/documents/odstoupeni.docx">ZDE</a>.
          </p>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Conditions",
};
</script>